import {
    applyMiddleware, compose, createStore
} from 'redux';
import {
    persistStore, persistReducer
} from 'redux-persist';
import thunk from 'redux-thunk';

import { fetchMiddlewareCreator } from '../../middleware';
import { AppContext } from '../app.types';
import { appEffectsMiddleware } from '../state/effects-middleware';
import { persistConfig } from './persist/store-persistor';
import { getRootReducer } from './root-reducer';

export const REDUX_DEVTOOLS_NAME = '3p-portal';

export function configureStore (context: AppContext) {
    // @ts-ignore
    const composeEnhancers: any =
        typeof window === 'object' &&
        // @ts-ignore
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
            // @ts-ignore
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
                name: REDUX_DEVTOOLS_NAME,
                trace: process.env.NODE_ENV === 'development'
            }) : compose;
    const enhancer = composeEnhancers(
        applyMiddleware(
            thunk.withExtraArgument(context),
            appEffectsMiddleware(context),
            fetchMiddlewareCreator()
        )
    );
    const persistedReducer = persistReducer(persistConfig, getRootReducer());
    const store = createStore(
        persistedReducer,
        enhancer
    );
    const persistor = persistStore(store);

    return {
        store,
        persistor
    };
}
